import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/components/icon/icon.module';
import { ButtonModule } from '../button/button.module';
import { SnackbarContainerComponent } from './snackbar-container.component';

@NgModule({
  imports: [CommonModule, IconModule, ButtonModule],
  declarations: [SnackbarContainerComponent],
  exports: [SnackbarContainerComponent],
})
export class SnackbarModule {}
